
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trains/reviews",
      function () {
        return require("private-next-pages/trains/reviews.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trains/reviews"])
      });
    }
  